import React, { useState } from "react";
import { Button } from "../../../design/button";
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
} from "../../../design/alert";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../../firebase";
import { Textarea } from "../../../design/textarea";
import { Field, Label } from "../../../design/fieldset";

interface Props {
  visitId: string;
}

const CancelVisitButton: React.FC<Props> = ({ visitId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isCanceling, setIsCanceling] = useState(false);
  const [cancelationReason, setCancelationReason] = useState("");

  const handleSubmit = async () => {
    setIsCanceling(true);
    try {
      const fn = httpsCallable(functions, "cancelVisit");
      await fn({ visitId, reason: cancelationReason || undefined });
      setIsOpen(false);
    } catch (error: any) {
      console.error("Error canceling visit:", error);
      window.alert(error.message || "Failed to cancel visit. Please try again later.");
    }
    setIsCanceling(false);
  };

  return (
    <>
      <Button type="button" color="red" onClick={() => setIsOpen(true)}>
        Cancel
      </Button>
      <Alert open={isOpen} onClose={setIsOpen}>
        <AlertTitle>Cancel Visit</AlertTitle>
        <AlertDescription>
          Are you sure you want to cancel this visit?
          <Field>
            <Label>Reason for cancellation</Label>
            <Textarea
              value={cancelationReason}
              onChange={(e) => setCancelationReason(e.target.value)}
              placeholder="Enter reason for cancellation"
            />
          </Field>
        </AlertDescription>
        <AlertActions>
          <Button plain onClick={() => setIsOpen(false)} disabled={isCanceling}>
            Keep Visit
          </Button>
          <Button color="red" onClick={handleSubmit} disabled={isCanceling}>
            Cancel Visit
          </Button>
        </AlertActions>
      </Alert>
    </>
  );
};

export default CancelVisitButton;
